import api from '@/services/api'
export default {
  onCompletion(data) {
    return api().post('completed', data)
  }
}

// CompletionService.onCompletion({
//   questions: {
//     "A1": "A101",
//     "D2": "D205",
//     // ...
//   }
// })

